import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import InputMC from '../../../components/InputMC';
import DropdownMC from '../../../components/DropdownMC';
import TitleMC from '../../../components/TitleMC';
import DatePickerMC from '../../../components/DatePickerMC';

const Step1Partial = ({ methods }) => {
  const { t } = useTranslation('createCampaign');
  const { current_retailer } = useSelector(
    (reduxState) => reduxState.createCampaignReducer
  );
  const { retailer } = useSelector((reduxState) => reduxState.mainReducer.currentRetailerUser);

  const editBusinessInfoPath = () => {
    window.location.href = `/retailers/${retailer.slug}/edit_business_info`;
  };

  const contact_groups_dropdown = (current_retailer?.catalogs?.contact_groups || []).map((group) => ({
    id: group.id,
    label: group.name
  }));

  const formValues = methods.getValues();

  return (
    <div className="tw-wrapper">
      <div id="step-1">
        <TitleMC text={t('step1.title')} variant="BASE" />
        <div className="tw-text-body tw-pb-6">{t('step1.description')}</div>
        <div className="tw-py-2">
          <InputMC
            name="name"
            placeholder={t('step1.campaignNamePlaceholder')}
            label={t('step1.campaignName')}
          />
        </div>
        <div className="tw-py-2">
          <DatePickerMC
            label={t('step1.campaignSendAt')}
            name="send_at"
            helperText={t('step1.campaingSendAtPlaceholder')}
            dateFormat="dd/MM/yyyy h:mm aa"
            timeInputLabel={`${t('step1.campaignTimeInputLabel')}:`}
            showTimeInput
            showMonthDropdown
            showYearDropdown
            timeZone={current_retailer?.catalogs?.timezone}
            minDate={new Date()}
            // eslint-disable-next-line react/no-unstable-nested-components
            helperChildren={() => (
              !current_retailer?.catalogs?.timezone
                ? (
                  <span onClick={() => editBusinessInfoPath()}>
                    <span className="tw-text-xs tw-text-blue-500 tw-italic tw-cursor-pointer">
                      {t('step1.timezoneNotConfigured')}
                    </span>
                  </span>
                )
                : (
                  <span className="tw-text-xs tw-italic">
                    {t('step1.timezoneNote')}
                  </span>
                )
            )}
          />
        </div>
        <div className="tw-py-2">
          <DropdownMC
            name="contact_group_id"
            id="contact_group"
            label={t('step1.clientList')}
            options={contact_groups_dropdown}
            defaultValue={formValues.contact_group_id}
            search
          />
        </div>
      </div>
    </div>
  );
};
export default Step1Partial;
